export abstract class AbstractDateService<T extends string> {
  abstract now(): T;
  abstract isValid(date: string): date is T;
}
